import {FC} from 'react'
import {PageTitle} from '@/_metronic/layout/core'
import {TableWrapper} from '@/components/table/TableWrapper'
import {getAuthHistory} from '../core/_requests'
import {ButtonProps, ModalWrapperProps} from '@/components/table/core/_types'
import {Modal} from '@/components/table/modal/Modal'
import {getColumns} from './columns/_columns'
import {FilterForm} from './components/FilterForm'
import BreadcrumbsBuilder from '@/components/layout/BreadcrumbsBuilder'
import {PurgeForm} from './components/PurgeForm'
import {useIntl} from 'react-intl'

const ListWrapper = () => {
  const intl = useIntl()

  const Breadcrumbs = BreadcrumbsBuilder([{
    title: `${intl.formatMessage({id: 'CORE.HOME.BREADCRUMBS'})}`,
    path: '/'
  }, {
    title: `${intl.formatMessage({id: 'CORE.USERS.LIST.BREADCRUMBS'})}`,
      path: '/app/users/list',
  }])

  const buttons: Array<ButtonProps> = [{
    label: `${intl.formatMessage({id: 'CORE.USERS.AUTH.BTN_PURGE'})}`,
    className: 'btn btn-danger me-3',
    icon: {
      name: 'file-deleted',
      className: 'fs-2'
    },
    openModal: 'purge'
  }]

  const ModalWrapper: FC<ModalWrapperProps> = ({itemForUpdate, action}) => {
    return (
      <>
        {itemForUpdate === null && action === 'purge' && (
          <Modal title={`${intl.formatMessage({id: 'CORE.USERS.AUTH.MODAL_PURGE.TITLE"'})}`}>
            <PurgeForm />
          </Modal>
        )}
      </>
    )
  }

  return (
    <>
      <PageTitle breadcrumbs={Breadcrumbs}>
        {intl.formatMessage({id: 'CORE.USERS.AUTH.PAGE_TITLE'})}
      </PageTitle>
      <TableWrapper
        dataProvider={getAuthHistory}
        cols={getColumns(intl)}
        queryId="USER_AUTH_LIST"
        lookup={{placeholder: `${intl.formatMessage({id: 'CORE.USERS.AUTH.LOOKUP_PLACEHOLDER'})}`}}
        modals={ModalWrapper}
        buttons={buttons}
        filters={{
          formFields: FilterForm,
          initialValues: {}
        }}
      />
    </>
  )
}

export default ListWrapper
